"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[1003],{

/***/ 69011:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "DownloadIcon": function() { return /* binding */ DownloadIcon; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* eslint-disable prettier/prettier */ 

var DownloadIcon = function(param) {
    var _size = param.size, size = _size === void 0 ? 24 : _size, _color = param.color, color = _color === void 0 ? "#161616" : _color, ariaLabel = param["aria-label"], tmp = param["aria-hidden"], ariaHidden = tmp === void 0 ? true : tmp;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
        width: "".concat(size),
        height: "".concat(size),
        viewBox: "0 0 24 24",
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        "aria-label": ariaLabel,
        "aria-hidden": ariaHidden,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M12.75 3C12.75 2.58579 12.4142 2.25 12 2.25C11.5858 2.25 11.25 2.58579 11.25 3V12.4619L11.2439 12.4548C11.0333 12.2062 10.827 11.9434 10.6341 11.6977L10.5893 11.6407C10.3971 11.396 10.1949 11.1388 10.0378 10.9773C9.74911 10.6802 9.27428 10.6735 8.97726 10.9622C8.68023 11.2509 8.67349 11.7257 8.96219 12.0227C9.05089 12.114 9.19651 12.2958 9.40971 12.5672L9.45677 12.6272C9.64683 12.8693 9.86981 13.1534 10.0995 13.4245C10.3457 13.715 10.6213 14.0168 10.8968 14.2515C11.0348 14.369 11.1904 14.485 11.3578 14.5746C11.5193 14.661 11.7417 14.75 12 14.75C12.2583 14.75 12.4807 14.661 12.6422 14.5746C12.8096 14.485 12.9652 14.369 13.1032 14.2515C13.3787 14.0168 13.6543 13.715 13.9005 13.4245C14.1302 13.1534 14.3531 12.8694 14.5432 12.6272L14.5903 12.5672C14.8035 12.2958 14.9491 12.114 15.0378 12.0227C15.3265 11.7257 15.3198 11.2509 15.0227 10.9622C14.7257 10.6735 14.2509 10.6802 13.9622 10.9773C13.8051 11.1388 13.6029 11.396 13.4107 11.6407L13.366 11.6976C13.173 11.9434 12.9668 12.2061 12.7561 12.4548L12.75 12.4619V3Z",
                fill: "".concat(color)
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                d: "M5.77686 9.74947C6.19081 9.73466 6.51437 9.38709 6.49957 8.97314C6.48476 8.55919 6.13719 8.23562 5.72324 8.25043C3.33578 8.33583 1.18215 10.1485 1.25164 12.7047C1.2676 13.2919 1.48301 13.9786 1.81373 15.0328L1.85773 15.1731C2.78521 18.1325 4.43179 20.9597 8.22351 21.629C8.90939 21.75 9.66853 21.75 10.9817 21.75H13.0184C14.3315 21.75 15.0907 21.75 15.7766 21.629C19.5683 20.9597 21.2149 18.1325 22.1424 15.1731L22.1863 15.0329C22.5171 13.9786 22.7325 13.2919 22.7484 12.7047C22.8179 10.1485 20.6643 8.33582 18.2768 8.25043C17.8629 8.23562 17.5153 8.55919 17.5005 8.97314C17.4857 9.38709 17.8093 9.73466 18.2232 9.74947C19.9512 9.81128 21.2919 11.0852 21.249 12.6639C21.2395 13.013 21.1008 13.4809 20.711 14.7245C19.8448 17.4882 18.477 19.6291 15.5158 20.1518C14.9756 20.2472 14.3564 20.2499 12.9303 20.2499H11.0698C9.64367 20.2499 9.02449 20.2472 8.48425 20.1518C5.52307 19.6291 4.15523 17.4882 3.28908 14.7245C2.8993 13.4809 2.76057 13.013 2.75108 12.6639C2.70817 11.0852 4.0489 9.81128 5.77686 9.74947Z",
                fill: "".concat(color)
            })
        ]
    });
};


/***/ }),

/***/ 97854:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "OpenDataGroupItem": function() { return /* binding */ OpenDataGroupItem; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87664);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63651);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(62009);






// Remove the last segment from URL to redirect to parent page
var getParentUrl = function(url) {
    if (!url) return "";
    var urlParts = url.split("/").filter(Boolean);
    if (urlParts.length > 1) {
        urlParts.pop(); // Remove last segment
        return "/" + urlParts.join("/");
    }
    return url;
};
var OpenDataGroupItem = function(param) {
    var Icon = param.Icon, Title = param.Title, url = param.url;
    var ref, ref1, ref2, ref3;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-4 items-start justify-between flex flex-col gap-6 rounded-2xl border border-neutral-300 animate-top-dga ",
        children: [
            (Icon === null || Icon === void 0 ? void 0 : (ref = Icon.value) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative rounded-full w-[48px] h-[48px]",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                    src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_3__.extractRelativePath)(Icon === null || Icon === void 0 ? void 0 : (ref1 = Icon.value) === null || ref1 === void 0 ? void 0 : ref1.src),
                    alt: (Icon === null || Icon === void 0 ? void 0 : (ref2 = Icon.value) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.alt) === null || ref3 === void 0 ? void 0 : ref3.trim()) || "Open data group icon",
                    layout: "fill",
                    className: "w-full h-full object-contain"
                })
            }),
            (Title === null || Title === void 0 ? void 0 : Title.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "font-bold text-lg",
                children: Title === null || Title === void 0 ? void 0 : Title.value
            }),
            url && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "flex flex-row gap-4 items-end justify-end w-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    href: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_3__.CleanRelativeLink)(getParentUrl(url)),
                    onClick: function(e) {
                        return e.stopPropagation();
                    },
                    className: "w-fit inline-flex items-center justify-center ".concat((0,components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_4__.getDgAButtonClassNames)("secondarySolid", "iconOnly lg")),
                    "aria-label": "View details",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                        src: "/Icons/arrow-right.svg",
                        alt: "",
                        className: "w-5 h-5 ".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_5__["default"])() ? "rotate-180" : ""),
                        "aria-hidden": "true"
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 33335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62099);
/* harmony import */ var _OpenDataGroupItem__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97854);
/* eslint-disable @typescript-eslint/no-explicit-any */ 




var OpenDataGroupPageContent = function(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.fields) || {}, Title = ref.Title, GroupTitle = ref.GroupTitle, Items = ref.Items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "",
        "aria-labelledby": (Title === null || Title === void 0 ? void 0 : Title.value) ? "open-data-group-title" : undefined,
        children: [
            (Title === null || Title === void 0 ? void 0 : Title.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "bg-primary-50 pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    id: "open-data-group-title",
                    className: "responsive font-bold text-3xl md:text-4xl md:font-semibold ",
                    children: Title === null || Title === void 0 ? void 0 : Title.value
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: "responsive py-10 flex flex-col gap-10",
                children: [
                    (GroupTitle === null || GroupTitle === void 0 ? void 0 : GroupTitle.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                        className: "text-2xl font-semibold",
                        children: GroupTitle === null || GroupTitle === void 0 ? void 0 : GroupTitle.value
                    }),
                    Items && (Items === null || Items === void 0 ? void 0 : Items.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
                        children: Items === null || Items === void 0 ? void 0 : Items.map(function(item) {
                            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_OpenDataGroupItem__WEBPACK_IMPORTED_MODULE_1__.OpenDataGroupItem, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({}, item === null || item === void 0 ? void 0 : item.fields), {
                                url: item === null || item === void 0 ? void 0 : item.url
                            }), item === null || item === void 0 ? void 0 : item.id);
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_4__/* .withDatasourceCheck */ .C)()(OpenDataGroupPageContent));


/***/ }),

/***/ 84782:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(16606);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(62099);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(87664);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(63651);
/* harmony import */ var components_Shared_dga_cta_box_DGACTABox__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(3415);
/* harmony import */ var components_Shared_dga_warning_box_DGAWarningBox__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(12620);
/* eslint-disable @typescript-eslint/no-unused-vars */ /* eslint-disable @typescript-eslint/no-explicit-any */ 







var OpenDataPageContent = function(props) {
    var ref, ref1, ref2, ref3, ref4;
    var ref5 = (props === null || props === void 0 ? void 0 : props.fields) || {}, Title = ref5.Title, IntroTitle = ref5.IntroTitle, IntroDescription = ref5.IntroDescription, PrinciplesItems = ref5.PrinciplesItems, Purpose = ref5.Purpose, PrinciplesTitle = ref5.PrinciplesTitle, CTAButtonText = ref5.CTAButtonText, CTAButtonUrl = ref5.CTAButtonUrl, WarningBoxLabel = ref5.WarningBoxLabel, WarningBoxContent = ref5.WarningBoxContent, CTABoxTitle = ref5.CTABoxTitle, CTABoxDescription = ref5.CTABoxDescription, CTABoxButtonText = ref5.CTABoxButtonText, CTABoxButtonLink = ref5.CTABoxButtonLink, HideWarningBox = ref5.HideWarningBox, HideCTABox = ref5.HideCTABox;
    var ref6, ref7, ref8;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        className: "",
        "aria-labelledby": (Title === null || Title === void 0 ? void 0 : Title.value) ? "open-data-title" : undefined,
        children: [
            (Title === null || Title === void 0 ? void 0 : Title.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "bg-primary-50 pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    id: "open-data-title",
                    className: "responsive font-bold text-3xl md:text-4xl md:font-semibold ",
                    children: Title === null || Title === void 0 ? void 0 : Title.value
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                children: [
                    ((IntroTitle === null || IntroTitle === void 0 ? void 0 : IntroTitle.value) || (IntroDescription === null || IntroDescription === void 0 ? void 0 : IntroDescription.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "responsive ",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                            className: " flex flex-col gap-6 md:w-3/4 py-10",
                            children: [
                                (IntroTitle === null || IntroTitle === void 0 ? void 0 : IntroTitle.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                    className: "text-2xl font-semibold animate-top-dga ",
                                    children: IntroTitle === null || IntroTitle === void 0 ? void 0 : IntroTitle.value
                                }),
                                (IntroDescription === null || IntroDescription === void 0 ? void 0 : IntroDescription.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                    className: "text-base animate-top-dga ",
                                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__/* .RichText */ .H, {
                                        field: IntroDescription
                                    })
                                })
                            ]
                        })
                    }),
                    (Purpose === null || Purpose === void 0 ? void 0 : Purpose.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "bg-neutral-100",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: "responsive flex flex-col gap-6 richtext-li-custom py-10",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__/* .RichText */ .H, {
                                field: Purpose,
                                className: "animate-top-dga "
                            })
                        })
                    }),
                    ((PrinciplesTitle === null || PrinciplesTitle === void 0 ? void 0 : PrinciplesTitle.value) || PrinciplesItems && (PrinciplesItems === null || PrinciplesItems === void 0 ? void 0 : PrinciplesItems.length) > 0) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: " responsive flex flex-col gap-8 py-10",
                        children: [
                            (PrinciplesTitle === null || PrinciplesTitle === void 0 ? void 0 : PrinciplesTitle.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "font-semibold text-2xl md:text-3xl md:font-bold animate-top-dga ",
                                children: PrinciplesTitle === null || PrinciplesTitle === void 0 ? void 0 : PrinciplesTitle.value
                            }),
                            PrinciplesItems && (PrinciplesItems === null || PrinciplesItems === void 0 ? void 0 : PrinciplesItems.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8",
                                children: PrinciplesItems === null || PrinciplesItems === void 0 ? void 0 : PrinciplesItems.map(function(card) {
                                    var ref, ref1, ref2, ref3;
                                    var ref4 = (card === null || card === void 0 ? void 0 : card.fields) || {}, Description = ref4.Description, Icon = ref4.Icon, Title = ref4.Title;
                                    return (Title === null || Title === void 0 ? void 0 : Title.value) || (Description === null || Description === void 0 ? void 0 : Description.value) ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                        className: "p-4 rounded-3xl border border-neutral-300 flex flex-col gap-6 animate-top-dga ",
                                        children: [
                                            (Icon === null || Icon === void 0 ? void 0 : (ref = Icon.value) === null || ref === void 0 ? void 0 : ref.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                className: "relative h-[48px] w-[48px] rounded-full",
                                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                                                    src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.extractRelativePath)(Icon === null || Icon === void 0 ? void 0 : (ref1 = Icon.value) === null || ref1 === void 0 ? void 0 : ref1.src),
                                                    alt: (Icon === null || Icon === void 0 ? void 0 : (ref2 = Icon.value) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.alt) === null || ref3 === void 0 ? void 0 : ref3.trim()) || "Open data icon",
                                                    layout: "fill",
                                                    className: "w-full h-full object-contain rounded-full"
                                                })
                                            }),
                                            ((Title === null || Title === void 0 ? void 0 : Title.value) || (Description === null || Description === void 0 ? void 0 : Description.value)) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                                className: "flex flex-col gap-2",
                                                children: [
                                                    (Title === null || Title === void 0 ? void 0 : Title.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h3", {
                                                        className: "text-lg font-bold",
                                                        children: Title === null || Title === void 0 ? void 0 : Title.value
                                                    }),
                                                    (Description === null || Description === void 0 ? void 0 : Description.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                                        className: "text-base richtext-li-custom",
                                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_7__/* .RichText */ .H, {
                                                            field: Description
                                                        })
                                                    })
                                                ]
                                            })
                                        ]
                                    }, card === null || card === void 0 ? void 0 : card.id) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {});
                                })
                            })
                        ]
                    }),
                    (CTAButtonText === null || CTAButtonText === void 0 ? void 0 : CTAButtonText.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: "responsive pb-10",
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_3___default()), {
                            passHref: true,
                            href: (CTAButtonUrl === null || CTAButtonUrl === void 0 ? void 0 : (ref = CTAButtonUrl.value) === null || ref === void 0 ? void 0 : ref.linktype) === "external" ? (ref6 = CTAButtonUrl === null || CTAButtonUrl === void 0 ? void 0 : (ref1 = CTAButtonUrl.value) === null || ref1 === void 0 ? void 0 : ref1.href) !== null && ref6 !== void 0 ? ref6 : "#" : (ref7 = (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_1__.extractRelativeURLPath)(CTAButtonUrl === null || CTAButtonUrl === void 0 ? void 0 : (ref2 = CTAButtonUrl.value) === null || ref2 === void 0 ? void 0 : ref2.href)) !== null && ref7 !== void 0 ? ref7 : "#",
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                                className: "animate-top-dga ".concat((0,components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_4__.getDgAButtonClassNames)("primary", "lg")),
                                target: (ref8 = CTAButtonUrl === null || CTAButtonUrl === void 0 ? void 0 : (ref3 = CTAButtonUrl.value) === null || ref3 === void 0 ? void 0 : ref3.target) !== null && ref8 !== void 0 ? ref8 : "_self",
                                rel: (CTAButtonUrl === null || CTAButtonUrl === void 0 ? void 0 : (ref4 = CTAButtonUrl.value) === null || ref4 === void 0 ? void 0 : ref4.target) === "_blank" ? "noopener noreferrer" : undefined,
                                children: CTAButtonText === null || CTAButtonText === void 0 ? void 0 : CTAButtonText.value
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: "responsive flex flex-col gap-8 pb-10",
                        children: [
                            (PrinciplesTitle === null || PrinciplesTitle === void 0 ? void 0 : PrinciplesTitle.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h2", {
                                className: "font-semibold text-2xl md:text-3xl md:font-bold animate-top-dga",
                                children: PrinciplesTitle.value
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_warning_box_DGAWarningBox__WEBPACK_IMPORTED_MODULE_6__.DGAWarningBox, {
                                label: WarningBoxLabel,
                                content: WarningBoxContent,
                                HideWarningBox: HideWarningBox
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(components_Shared_dga_cta_box_DGACTABox__WEBPACK_IMPORTED_MODULE_5__.DGACTABox, {
                                title: CTABoxTitle,
                                description: CTABoxDescription,
                                buttonText: CTABoxButtonText,
                                buttonLink: CTABoxButtonLink,
                                HideCTABox: HideCTABox
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_8__/* .withDatasourceCheck */ .C)()(OpenDataPageContent));


/***/ }),

/***/ 29483:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "SocialMediaCard": function() { return /* binding */ SocialMediaCard; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(25675);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(2637);
/* harmony import */ var _heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87664);
/* harmony import */ var components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(62009);
/* harmony import */ var components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(63651);







var SocialMediaCard = function(param) {
    var Icon = param.Icon, PlatformTitle = param.PlatformTitle, PlatformUrl = param.PlatformUrl;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6;
    var ref7;
    var href = (ref7 = PlatformUrl === null || PlatformUrl === void 0 ? void 0 : (ref = PlatformUrl.value) === null || ref === void 0 ? void 0 : ref.href) !== null && ref7 !== void 0 ? ref7 : "#";
    var isDisabled = !(PlatformUrl === null || PlatformUrl === void 0 ? void 0 : (ref1 = PlatformUrl.value) === null || ref1 === void 0 ? void 0 : ref1.href);
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "p-4 border border-neutral-300 rounded-2xl flex flex-col gap-4 animate-top-dga",
        children: [
            (Icon === null || Icon === void 0 ? void 0 : (ref2 = Icon.value) === null || ref2 === void 0 ? void 0 : ref2.src) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "relative w-[48px] h-[48px] rounded-full",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_1___default()), {
                    src: (0,components_Shared_DomainSplit__WEBPACK_IMPORTED_MODULE_3__.extractRelativePath)(Icon === null || Icon === void 0 ? void 0 : (ref3 = Icon.value) === null || ref3 === void 0 ? void 0 : ref3.src),
                    alt: (Icon === null || Icon === void 0 ? void 0 : (ref4 = Icon.value) === null || ref4 === void 0 ? void 0 : ref4.alt) || "Social media icon",
                    layout: "fill",
                    className: "object-contain w-full h-full"
                })
            }),
            (PlatformTitle === null || PlatformTitle === void 0 ? void 0 : PlatformTitle.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("p", {
                className: "text-lg font-bold",
                children: PlatformTitle.value
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_2___default()), {
                href: href,
                passHref: true,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                    target: (PlatformUrl === null || PlatformUrl === void 0 ? void 0 : (ref5 = PlatformUrl.value) === null || ref5 === void 0 ? void 0 : ref5.target) || "_self",
                    rel: (PlatformUrl === null || PlatformUrl === void 0 ? void 0 : (ref6 = PlatformUrl.value) === null || ref6 === void 0 ? void 0 : ref6.target) === "_blank" ? "noopener noreferrer" : undefined,
                    className: "self-end inline-flex items-center justify-center ".concat((0,components_Shared_dga_button_DGAButton__WEBPACK_IMPORTED_MODULE_5__.getDgAButtonClassNames)("secondarySolid", "lg", "".concat((0,components_Shared_isRtl__WEBPACK_IMPORTED_MODULE_4__["default"])() ? "rotate-180" : "", " ").concat(isDisabled ? "opacity-50 pointer-events-none" : ""))),
                    "aria-label": (PlatformTitle === null || PlatformTitle === void 0 ? void 0 : PlatformTitle.value) ? "Open ".concat(PlatformTitle.value, " profile") : "Open social media link",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_heroicons_react_20_solid__WEBPACK_IMPORTED_MODULE_6__, {
                        width: 24,
                        height: 24,
                        "aria-hidden": true
                    })
                })
            })
        ]
    });
};


/***/ }),

/***/ 60658:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(62099);
/* harmony import */ var _SocialMediaCard__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(29483);




var SocialMediaPageContent = function(props) {
    var ref = (props === null || props === void 0 ? void 0 : props.fields) || {}, Title = ref.Title, Items = ref.Items;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("section", {
        "aria-labelledby": (Title === null || Title === void 0 ? void 0 : Title.value) ? "social-media-title" : undefined,
        children: [
            (Title === null || Title === void 0 ? void 0 : Title.value) && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("header", {
                className: "bg-primary-50 pb-10",
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("h1", {
                    id: "social-media-title",
                    className: "responsive font-bold text-3xl md:text-4xl md:font-semibold ",
                    children: Title.value
                })
            }),
            Items && (Items === null || Items === void 0 ? void 0 : Items.length) > 0 && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: "responsive py-10 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4",
                children: Items.map(function(card) {
                    /*#__PURE__*/ return (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_SocialMediaCard__WEBPACK_IMPORTED_MODULE_1__.SocialMediaCard, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, card === null || card === void 0 ? void 0 : card.fields), card === null || card === void 0 ? void 0 : card.id);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = ((0,_sitecore_jss_sitecore_jss_nextjs__WEBPACK_IMPORTED_MODULE_3__/* .withDatasourceCheck */ .C)()(SocialMediaPageContent));


/***/ })

}]);